import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../shared/constants/constants';
import { GlobalFilterService } from '../shared/services/global-filter.service';
import { Router } from '@angular/router';
import { IOfficeSelectorModel } from '../modules/jobs-list-master/modal/office-selector-model';
import { ToasterService, ToasterType } from '@tt-chvac/core';
import { AuthenticationService } from '@tt-chvac/authentication';
import { AuthorizeAccessService } from '../shared/services/authorize-access.service';
import { FeatureEnum } from '@tt-chvac/core-sales-web';

@Component({
    selector: 'app-redirect-jobs-list',
    templateUrl: './redirect-jobs-list.component.html',
    standalone: false
})
export class RedirectJobsListComponent implements OnInit {
  userId: string;

  constructor(
    private filterService: GlobalFilterService,
    private authenticationService: AuthenticationService,
    private router: Router,
    public toasterService: ToasterService,
    private authorizeAccessService: AuthorizeAccessService,
    private appConstants: AppConstants) {

  }

  ngOnInit() {
    this.authenticationService.isAuthenticated().then((value) => {
      if (value) {
        this.filterService.getDefaultOffice().subscribe((data: IOfficeSelectorModel) => {
          if (data) {
            localStorage.setItem('userHasSalesOffice', 'true');
            this.router.navigate(['/jobs-list', data.drAddressId]);
          } else {
            // If readonly user then redirect to project screen based on type
            if (this.authorizeAccessService.isReadOnlyUser(FeatureEnum.CreditProject)) {
              // No sales office available for readonly user and homepagelist route required drAddressId
              // Passing support drAddressId as default value
              this.router.navigate(['/projects', this.appConstants.SUPPORT_DATABASE_DR_ADDRESS_ID]);
            } else if (this.authorizeAccessService.hasFeatureAccess(FeatureEnum.TimeEntryUser) ||
              this.authorizeAccessService.hasFeatureAccess(FeatureEnum.TimeEntryManager)) {
              // If the user is a time entry user or manager, redirect to the time entry page.
              this.router.navigate(['/time-entry']);
            } else {
              this.showErrorMessage();
            }
          }
        },
          (error) => {
            this.showErrorMessage();
          });
      }
    });
  }

  showErrorMessage() {
    this.toasterService.setToaster(ToasterType.ERROR, this.appConstants.ACCESS_DENIED);
    setTimeout(() => {
      this.authenticationService.logout();
    }, 2000);
  }
}
